import { render, staticRenderFns } from "./VehicleDetail.vue?vue&type=template&id=1fc05b2c&scoped=true&"
import script from "./VehicleDetail.vue?vue&type=script&lang=ts&"
export * from "./VehicleDetail.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleDetail.vue?vue&type=style&index=0&id=1fc05b2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc05b2c",
  null
  
)

export default component.exports